<template>
  <el-dialog
      :visible.sync="visible"
      title="开票明细"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <SweetTable ref="table" url="/erp/box/detail/page" :query-form="dataForm"
                :summaries-column="['totalCount','totalPrice']"
                :auto-load="false" :height="400" :before-table-binding="beforeTableBinding" api-version="v2">
      <el-table-column label="外销合同号" prop="agreementCode" align="center" min-width="160">
      </el-table-column>
      <el-table-column label="出货工厂" align="center" min-width="200" prop="factoryName">
      </el-table-column>
      <el-table-column
          label="品番号"
          prop="product.code"
          align="center"
          min-width="160"
      >
      </el-table-column>
      <el-table-column
          label="SKU"
          prop="product.skuCode"
          align="center"
          min-width="160"
      >
      </el-table-column>
      <el-table-column label="品名" align="center" min-width="160" prop="product.name">
      </el-table-column>
      <el-table-column label="颜色" align="center" min-width="140" prop="product.color">
      </el-table-column>
      <el-table-column label="规格" align="center" min-width="140" prop="product.size">
      </el-table-column>
      <el-table-column label="中文品名" align="center" min-width="140" prop="product.nameZh">
      </el-table-column>
      <el-table-column label="出货数量" align="center" width="110" prop="totalCount">
      </el-table-column>
      <el-table-column label="出货单价" align="center" width="200" prop="price">
        <template slot-scope="scope">
          <div style="display: flex;align-items: center;justify-content: center;">
            <template v-if="!scope.row.isEdit">
              <div style="margin-right: 10px;">{{ scope.row.price }}</div>
              <i class="el-icon-edit pointer" v-if="$hasPermission('erp:sell:code:edit')" style="color:#409EFF;" @click="scope.row.isEdit=true"></i>
            </template>
            <template v-else>
              <el-input v-model="scope.row.price" size="mini" style="width: 80px; margin-right: 10px;"></el-input>
              <i class="el-icon-check pointer" style="color:#409EFF;" @click="editPrice(scope.row)"></i>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="小计" align="center" width="110" prop="totalPrice">
      </el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

export default {
  name: 'detail-dialog',
  mixins: [SweetTable],
  data () {
    return {
      visible: false,
      dataList: [],
      dataForm: {
        pid: '',
        needPage: false,
        page: 1,
        limit: 100000,
        formType: 'sell'
      }
    }
  },
  methods: {
    async editPrice (row) {
      try {
        await this.$api2.post('/erp/box/detail/editPrice', row)
        this.reload()
        this.$message.success('修改成功')
        row.isEdit = false
      } catch (e) {
        console.log(e)
        this.$message.error('修改失败')
      }
    },
    init (pid) {
      this.dataForm.pid = pid
      this.visible = true
      this.$nextTick(() => {
        this.reload()
      })
    },
    beforeTableBinding (dataList) {
      if (dataList.length === 0) {
        return
      }
      dataList.forEach(row => {
        row.isEdit = false
        row.totalPrice = new BigNumber(row.totalCount).multipliedBy(row.price).toFixed(2)
      })
    }
  }
}
</script>

<style scoped>

</style>
